/**
 * Empty State View Component
 * 
 * Displays when the user has no investment accounts connected.
 * Provides options to connect Wealthica or add manual assets.
 * Used as the initial view in the Investments page for new users.
 */

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Plug, Plus, CircleDollarSign } from "lucide-react";

interface EmptyStateViewProps {
  onConnectWealthica: () => void;
  onAddManualAsset?: () => void;
}

export function EmptyStateView({ onConnectWealthica, onAddManualAsset }: EmptyStateViewProps) {
  return (
    <Card className="text-center">
      <CardContent className="pt-8 pb-6 px-6">
        <div className="bg-slate-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
          <CircleDollarSign className="h-8 w-8 text-blue-600" />
        </div>
        <h3 className="text-lg font-semibold mb-2">No Accounts Yet</h3>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">View investment accounts, digital assets, and add custom assets to build and analyze everything in one place.</p>
        <div className="flex gap-2 justify-center">
          <Button className="gap-1" onClick={onConnectWealthica}>
            <Plug className="h-4 w-4" />
            Connect Accounts
          </Button>
          {onAddManualAsset && (
            <Button variant="outline" className="gap-1" onClick={onAddManualAsset}>
              <Plus className="h-4 w-4" />
              Add Asset
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
